<template>
  <div class="py-4 container-fluid">
    <!-- Statistics Cards -->
    <div class="row">
      <!-- <div
        class="col-xl-3 col-sm-6 mb-4"
        v-for="stat in stats"
        :key="stat.title"
      >
        <div class="card h-100">
          <div class="card-body">
            <div class="d-flex align-items-center">
              <div
                :class="`icon icon-shape text-white text-center me-3 ${stat.iconBackground}`"
              >
                <i :class="stat.icon"></i>
              </div>
              <div>
                <h6 class="mb-0">{{ stat.title }}</h6>
                <h5 class="mb-0">{{ stat.value }}</h5>
              </div>
            </div>
            <p class="text-sm mt-2" :class="stat.percentage.color">
              {{ stat.percentage.value }} since last week
            </p>
          </div>
        </div>
      </div> -->

      <div class="col-xl-3 col-sm-6 mb-4">
        <a href="revenue_by_dates">
          <div class="card h-100 data-link">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div
                  class="icon icon-shape text-white text-center me-3 bg-gradient-success"
                >
                  <i class="ni ni-money-coins"></i>
                </div>
                <div>
                  <h6 class="mb-0">Revenue Today</h6>
                  <h5 class="mb-0">KSH. {{ api_data.revenue_today }}</h5>
                </div>
              </div>
              <p class="text-sm mt-2 text-success">all collections today</p>
            </div>
          </div>
        </a>
      </div>

      <div class="col-xl-3 col-sm-6 mb-4">
        <a href="pending_invoices">
          <div class="card h-100 data-link">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div
                  class="icon icon-shape text-white text-center me-3 bg-gradient-warning"
                >
                  <i class="ni ni-credit-card"></i>
                </div>
                <div>
                  <h6 class="mb-0">Pending Invoices</h6>
                  <h5 class="mb-0">
                    KSH. {{ api_data.pending_invoices ?? null }}
                  </h5>
                </div>
              </div>
              <p class="text-sm mt-2 text-danger">all invoices unpaid</p>
            </div>
          </div>
        </a>
      </div>

      <div class="col-xl-3 col-sm-6 mb-4">
        <a href="insurance_claims_overview">
          <div class="card h-100 data-link">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div
                  class="icon icon-shape text-white text-center me-3 bg-gradient-info"
                >
                  <i class="ni ni-briefcase-24"></i>
                </div>
                <div>
                  <h6 class="mb-0">Insurance Claims</h6>
                  <h5 class="mb-0">
                    KSH. {{ api_data.insuranceClaims ?? null }}
                  </h5>
                </div>
              </div>
              <p class="text-sm mt-2 text-success">pending claims</p>
            </div>
          </div>
        </a>
      </div>

      <div class="col-xl-3 col-sm-6 mb-4">
        <a href="expenses_overview">
          <div class="card h-100 data-link">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <div
                  class="icon icon-shape text-white text-center me-3 bg-gradient-danger"
                >
                  <i class="ni ni-cart"></i>
                </div>
                <div>
                  <h6 class="mb-0">Expenses Today</h6>
                  <h5 class="mb-0">
                    KSH. {{ api_data.expensesToday ?? null }}
                  </h5>
                </div>
              </div>
              <p class="text-sm mt-2 text-danger">all categories expenses</p>
            </div>
          </div>
        </a>
      </div>

      <!-- ===================================================  -->
      <div class="col-xl-3 col-sm-6 mb-4">
        <a href="inventory_and_sales">
          <div class="card data-link cardlinked">
            <h5>Inventories & Sales</h5>
          </div>
        </a>
      </div>
      <div class="col-xl-3 col-sm-6 mb-4">
        <a href="accounts">
          <div class="card data-link cardlinked">
            <h5>Chart of Accounts</h5>
          </div>
        </a>
      </div>
      <!-- po_processing -->
      <div class="col-xl-3 col-sm-6 mb-4">
        <a href="/purchase_orders">
          <div class="card data-link cardlinked">
            <h5>P.O Processing</h5>
          </div>
        </a>
      </div>

      <div class="col-xl-3 col-sm-6 mb-4">
        <a href="#">
          <div class="card data-link cardlinked">
            <h5>.</h5>
          </div>
        </a>
      </div>

      <!-- <div class="col-xl-3 col-sm-6 mb-4">
        <a href="finance_book">
          <div class="card data-link cardlinked">
            <h5>Cash Book</h5>
          </div>
        </a>
      </div> -->

      <!-- end cards -->
    </div>

    <!-- Finance Trend Chart & Summary -->
    <div class="row mt-4">
      <div class="col-lg-8 mb-4">
        <div class="card h-100">
          <div class="card-header pb-0">
            <h6>Monthly Revenue & Expenses</h6>
          </div>
          <div class="card-body">
            <canvas id="finance-chart" height="100"></canvas>
          </div>
        </div>
      </div>

      <div class="col-lg-4 mb-4">
        <div class="card h-100">
          <div class="card-header pb-0">
            <h6>Finance Overview</h6>
          </div>
          <div class="card-body">
            <ul class="list-group">
              <!-- <li
                v-for="item in financeMetrics"
                :key="item.title"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>{{ item.title }}</span>
                <span class="fw-bold">{{ item.value }}</span>
              </li> -->

              <!-- finance metrics table -->
              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>Total Revenue This Month</span>
                <span class="fw-bold">
                  KSH. {{ api_data.revenue_this_month ?? null }}</span
                >
              </li>

              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>Total Expenses This Month</span>
                <span class="fw-bold">
                  KSH. {{ api_data.expenses_this_month ?? null }}</span
                >
              </li>

              <!-- <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>Net Profit</span>
                <span class="fw-bold">
                  KSH. {{ api_data.net_profit ?? null }}</span
                >
              </li> -->

              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>Outstanding Insurance Claims</span>
                <span class="fw-bold">
                  KSH. {{ api_data.insuranceClaims ?? null }}</span
                >
              </li>

              <li
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                <span>Pending Invoices</span>
                <span class="fw-bold">
                  KSH. {{ api_data.pending_invoices ?? null }}</span
                >
              </li>

              <!-- end finance metrics table -->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Revenue & Expenses Overview Styled Cards -->
    <div class="row mt-4">
      <!-- Revenue Metrics Card -->
      <div class="col-lg-6 mb-4">
        <div class="card h-100 shadow-sm">
          <div class="card-header bg-primary text-white">
            <h6 class="mb-0">Revenue Metrics</h6>
          </div>
          <div class="card-body">
            <!-- Top line summary -->
            <div class="mb-3 d-flex justify-content-between">
              <div>
                <small class="text-muted">Today</small>
                <h5 class="mb-0 text-success">
                  KSH. {{ api_data.revenue_today ?? null }}
                </h5>
              </div>
              <div>
                <small class="text-muted">This Month</small>
                <h5 class="mb-0 text-success">
                  {{ api_data.revenue_this_month ?? null }}
                </h5>
              </div>
              <div>
                <small class="text-muted">Year-to-Date</small>
                <h5 class="mb-0 text-success">
                  {{ revenueSummary.ytd ?? null }}
                </h5>
              </div>
            </div>

            <!-- Revenue by Department -->
            <div class="mb-3">
              <h6 class="text-secondary mb-2">By Department</h6>
              <div v-if="api_data.revenueByDept" class="d-flex flex-wrap gap-3">
                <div
                  v-for="dept in api_data.revenueByDept"
                  :key="dept.name"
                  class="badge bg-info text-dark px-3 py-2"
                >
                  {{ dept.name }}: <strong>KSH. {{ dept.value }}</strong>
                </div>
              </div>
            </div>

            <!-- Payment Mode -->
            <div class="mb-3">
              <h6 class="text-secondary mb-2">By Payment Mode</h6>
              <div
                v-if="api_data.revenueByPayment"
                class="d-flex flex-wrap gap-3"
              >
                <div
                  v-for="mode in api_data.revenueByPayment"
                  :key="mode.name"
                  class="badge bg-success text-white px-3 py-2"
                >
                  {{ mode.payment_method }}:
                  <strong>KSh. {{ mode.total_amount }}</strong>
                </div>
              </div>
            </div>

            <!-- Top Earners -->
            <div>
              <h6 class="text-secondary mb-2">
                Top Earning Service & Insurance
              </h6>
              <p class="mb-1">
                <strong>{{ topEarningService.name ?? null }}:</strong>
                KSH. {{ topEarningService.value ?? null }}
              </p>
              <p>
                <!-- <strong>{{ topInsurance.name }}:</strong>
                {{ topInsurance.value }} -->
              </p>
              <p class="text-warning">
                <strong>Outstanding Invoices:</strong>
                <!-- {{ api_data.outstandingInvoices }} -->
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Expenses Overview Card -->
      <div class="col-lg-6 mb-4">
        <div class="card h-100 shadow-sm">
          <div class="card-header bg-danger text-white">
            <h6 class="mb-0">Expenses Overview</h6>
          </div>
          <div class="card-body">
            <!-- Expense totals -->
            <div class="mb-3 d-flex justify-content-between">
              <div>
                <small class="text-muted">Today</small>
                <h5 class="mb-0 text-danger">{{ expensesSummary.today }}</h5>
              </div>
              <div>
                <small class="text-muted">This Month</small>
                <h5 class="mb-0 text-danger">{{ expensesSummary.month }}</h5>
              </div>
              <div>
                <small class="text-muted">Year-to-Date</small>
                <h5 class="mb-0 text-danger">{{ expensesSummary.ytd }}</h5>
              </div>
            </div>

            <!-- Expense Categories -->
            <div class="mb-3">
              <h6 class="text-secondary mb-2">Expense Categories</h6>
              <div class="d-flex flex-wrap gap-3">
                <div
                  v-for="cat in expenseCategories"
                  :key="cat.name"
                  class="badge bg-warning text-dark px-3 py-2"
                >
                  {{ cat.name }}: <strong>{{ cat.value }}</strong>
                </div>
              </div>
            </div>

            <!-- Pharmacy Purchase Orders -->
            <div class="mb-3">
              <h6 class="text-secondary mb-2">Pharmacy Purchase Orders</h6>
              <p><strong>Paid:</strong> {{ pharmacyPOs.paid }}</p>
              <p><strong>Pending:</strong> {{ pharmacyPOs.pending }}</p>
            </div>

            <!-- Drug Purchases by Supplier -->
            <div>
              <h6 class="text-secondary mb-2">Drug Purchases by Supplier</h6>
              <div class="d-flex flex-wrap gap-3">
                <div
                  v-for="supplier in drugPurchasesBySupplier"
                  :key="supplier.supplier_id"
                  class="badge bg-secondary text-white px-3 py-2"
                >
                  {{ supplier.name }}:
                  <strong>Ksh. {{ supplier.value }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { generalApiRequest } from "../../api/apiIndex";
export default {
  name: "FinanceIndex",
  data() {
    return {
      api_data: {},
      // end real
      revenueSummary: {},
      revenueByDept: [],
      revenueByPayment: [],
      topEarningService: {},
      topInsurance: {},
      outstandingInvoices: "",

      expensesSummary: {},
      expenseCategories: [],
      pharmacyPOs: {},
      drugPurchasesBySupplier: [],
    };
  },

  methods: {
    renderChart() {
      const ctx = document.getElementById("finance-chart").getContext("2d");

      // ---------------------------------------------------------------------
      new Chart(ctx, {
        type: "line",
        data: {
          labels: this.api_data.monthlyTrends.labels,
          datasets: [
            {
              label: "Revenue",
              data: this.api_data.monthlyTrends.revenue,
              borderColor: "#4caf50",
              tension: 0.4,
              fill: false,
            },
            {
              label: "Expenses",
              data: this.api_data.monthlyTrends.expenses,
              borderColor: "#f44336",
              tension: 0.4,
              fill: false,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: true },
          },
        },
      });
      // ----------------------------------------------------------------------
    },

    get_item(obj, param) {
      console.log(param);

      console.log(JSON.stringify(obj));
      return obj;
    },

    async callApiData() {
      const url = "getFinanceDashboardData";
      const response = await generalApiRequest(url, "GET", {}, 1);
      this.api_data = response.data;
      this.revenueSummary = response.data.revenueSummary;
      this.expensesSummary = response.data.expensesSummary;
      this.expenseCategories = response.data.expenseCategories;
      this.pharmacyPOs = response.data.pharmacyPOs;
      this.drugPurchasesBySupplier = response.data.drugPurchasesBySupplier;
      this.revenueByDept = response.data.revenueByDept;
      this.revenueByPayment = response.data.revenueByPayment;
      // console.log(this.revenueSummary.ytd);

      this.topEarningService = response.data.topEarningService;
      if (response) {
        this.renderChart();
      }
      // console.log(response);
    },
  },

  mounted() {
    this.callApiData();
  },
};
</script>

<style>
.data-link:hover {
  transform: translateY(-5px);
  border-color: #007bff;
  background-color: rgba(101, 50, 50, 0.5);
}
.cardlinked {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 600;
  color: #555;
}
</style>
